import i18n from '@/i18n';

// 검증 메시지는 호출 시점의 현재 locale로 번역한다.
// 정적 클래스라 컴포넌트 $t를 쓸 수 없어 전역 i18n 인스턴스를 직접 사용한다.
const t = (key) => i18n.global.t(key);

/**
 * 작업 지시서 관련 검증 유틸리티
 */
export class ValidationUtils {

  /**
   * Step1 - 거래처 선택 검증
   */
  static validateStep1(selectedClient) {
    if (!selectedClient) {
      return {
        isValid: false,
        message: t('workorder_validate_select_client')
      };
    }
    return { isValid: true };
  }

  /**
   * Step2 - 환자 정보 검증
   */
  static async validateStep2(step2Ref) {
    if (!step2Ref) {
      return {
        isValid: false,
        message: t('workorder_validate_step_component_missing')
      };
    }

    const isValid = await step2Ref.validateForm();
    return {
      isValid,
      message: isValid ? '' : t('workorder_validate_patient_info')
    };
  }

  /**
   * Step3 - 상세 정보 검증
   */
  static async validateStep3(step3Ref) {
    if (!step3Ref) {
      return {
        isValid: false,
        message: t('workorder_validate_step_component_missing')
      };
    }

    const isValid = await step3Ref.validateForm();
    return {
      isValid,
      message: isValid ? '' : t('workorder_validate_detail_info')
    };
  }

  /**
   * 최종 데이터 검증
   */
  static validateFinalData(selectedClient, certificateInfo, workOrderData) {
    const errors = [];

    if (!selectedClient) {
      errors.push(t('workorder_validate_no_client'));
    }

    if (!certificateInfo || !certificateInfo.name) {
      errors.push(t('workorder_validate_no_patient'));
    }

    if (!workOrderData || !workOrderData.selectedTeeth || workOrderData.selectedTeeth.length === 0) {
      errors.push(t('workorder_validate_no_teeth'));
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  }
}
